var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#454851"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.275 15.6666H21.725V19.3H26.275V15.6666Z",
    fill: "#A0AABB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.525 15.6666V19.3H32.225C31.8 17.0083 30.1084 15.675 27.525 15.6666Z",
    fill: "#A0AABB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6666 20.55V27.4917C15.6666 30.525 17.475 32.3334 20.5083 32.3334H27.4916C30.525 32.3334 32.3333 30.525 32.3333 27.4917V20.55H15.6666ZM26.0333 27.4834L24.3 28.4834C23.9333 28.6917 23.575 28.8 23.2416 28.8C22.9916 28.8 22.7666 28.7417 22.5583 28.625C22.075 28.35 21.8083 27.7834 21.8083 27.05V25.05C21.8083 24.3167 22.075 23.75 22.5583 23.475C23.0416 23.1917 23.6583 23.2417 24.3 23.6167L26.0333 24.6167C26.675 24.9834 27.025 25.5 27.025 26.0584C27.025 26.6167 26.6666 27.1084 26.0333 27.4834Z",
    fill: "#A0AABB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.475 15.6666C17.8917 15.675 16.2 17.0083 15.775 19.3H20.475V15.6666Z",
    fill: "#A0AABB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoicon);
export default __webpack_public_path__ + "static/media/videoicon.4448c4a277703a18994aca1af0eef84c.svg";
export { ForwardRef as ReactComponent };